import React, { useEffect, useState } from "react";
import { Form, Input, Button, Row, Col, Modal, Typography, message, Collapse, Card, DatePicker, Select, Spin } from "antd";
import { ExclamationCircleOutlined, DeleteOutlined, PlusCircleOutlined, LeftOutlined, RightOutlined} from "@ant-design/icons";
import { useHistory, useLocation } from "react-router-dom";
import LeftLayout from "../../pageHeader/LeftLayout";
import { routes } from "../../../routes/Routes";
import CollapsePanel from "antd/lib/collapse/CollapsePanel";
import "../../../assets/dist/ConsumerProject/Consumer/ConsumerApplicantCommon.css";
import _consumerService from "../../../modules/consumerService";
import { COMMON_ERROR_MSG, SUBMISSION_FAILED } from "../../../constants/constants";
import moment from "moment";
import { ScreenNamebalancesheetasset } from "../../../constants/DataConstants";
import CurrencyInput from "../../../components/CurrencyInput";
import ConsumerApplicationProgressBar from "../Consumer/ConsumerApplicationProgressBar";
import ConsumerShowApplicationId from "../Consumer/ConsumerShowApplicationId";


const { confirm } = Modal;
const { Panel } = Collapse;
const { Title } = Typography;
const { Option } = Select;

const normalizeNumber = (val) => {
  if (!val) return "";
  return val
    .toString()
    .replace(/,/g, "")
    .replace(/[^0-9.-]/g, "");
};

const BalanceSheetAssetsForConsumer = () => {
    const [form] = Form.useForm();
    const [loading, setLoading] = useState(false);
    const [assets, setAssets] = useState([
        { Id: null, nameOfFinancialInstitution: "", typeOfAccount: "", Owner: "", toWhom: "", total: "" },
    ]);
    const [ListedStocksandBonds, setListedStocksandBonds] = useState([
        { Id: null, noOfShareOrPerValue: "", whichExchange: "", Description: "", Owner: "", CostBasis: "", marketValue: "", toWhom: "" },
    ]);
    const [accountsAndNotesReceivable, setaccountsAndNotesReceivable] = useState([
        { Id: null, nameOfDebtor: "", collateral: "", interestRate: "", payable: "", maturityDate: "", unpaidBalance: "", toWhom: "" },
    ]);
    const [cashValueAndLifeInsurance, setCashValueAndLifeInsurance] = useState([
        { Id: null, amount: "", nameOfCompany: "", beneficiary: "", owner: "", loans: "", cashValue: "" },
    ]);
    const [balancesheetassetInfo, setBalancesheetassetInfo] = useState({});
    const applicationId = localStorage.getItem("ApplicationObjId");
   // const [assetErrors, setAssetErrors] = useState([]);
    // const [listedStockErrors, setListedStockErrors] = useState([]);
    // const [accountsAndNotesErrors, setAccountsAndNotesErrors] = useState([]);
    // const [cashValueErrors, setCashValueErrors] = useState([]);
    const history = useHistory();
    const ApplicationId = localStorage.getItem("ApplicationObjId");

    


    const [Expenses, setExpenses] = useState({});
    const location = useLocation();
    let locData = location.state;
    let applnObjId = "";
    let activeKeyTab = null;
    let fromDashboard = false;
    let selectedApplicationFlow = null;

    if (locData && locData.applicationObjId) {
        applnObjId = locData.applicationObjId;
    }

    if (locData && locData.isFromDashboard) {
        fromDashboard = locData.isFromDashboard;
    }
    if (locData && locData.activeKey) {
        activeKeyTab = locData.activeKey;
    }
     if (locData && locData.selectedDocumentOption) {
        selectedApplicationFlow = locData.selectedDocumentOption;
    }

    const [appObjId] = useState(applnObjId);
    const [isFromDashboard] = useState(fromDashboard);
    const [tabActiveKey] = useState(activeKeyTab);
    const [selectedApplicationDocFlow] = useState(selectedApplicationFlow);
    const addAsset = () => {
        setAssets([
            ...assets,
            { Id: null, nameOfFinancialInstitution: "", typeOfAccount: "", Owner: "", toWhom: "", total: "" },
        ]);
    };
    const addListedStock = () => {
        setListedStocksandBonds([
            ...ListedStocksandBonds,
            {
                Id: null,
                noOfShareOrPerValue: "",
                whichExchange: "",
                Description: "",
                Owner: "",
                CostBasis: "",
                marketValue: "",
                toWhom: "",
            },
        ]);
    };
    const addAccountsNoter = () => {
        setaccountsAndNotesReceivable([
            ...accountsAndNotesReceivable,
            { Id: null, nameOfDebtor: "", collateral: "", interestRate: "", payable: "", maturityDate: "", unpaidBalance: "", toWhom: "" },
        ]);
    }
    const addCashValueAndLifeInsurance = () => {
        setCashValueAndLifeInsurance([
            ...cashValueAndLifeInsurance,
            { Id: null, amount: "", nameOfCompany: "", beneficiary: "", owner: "", loans: "", cashValue: "" },
        ]);
    }

    const deleteAsset = (assetId, index) => {
        confirm({
            title: "Are you sure you want to delete?",
            icon: <ExclamationCircleOutlined />,
            okText: "Yes",
            cancelText: "No",
            async onOk() {
                if (assetId) {
                    try {
                        const res = await _consumerService.deleteCashShortTermInvestmentsByCashID(assetId);
                        if (res.data.IsSuccess) {
                            message.success(res?.data?.Message);
                            fetchAssets();
                            setAssets(prevAssets => prevAssets.filter(a => a.Id !== assetId));
                        } else {
                            message.error(res?.data?.Message || COMMON_ERROR_MSG);
                        }
                        // const updatedErrors = [...assetErrors];
                        // updatedErrors.splice(index, 1);
                        // setAssetErrors(updatedErrors);
                    } catch (error) {
                        message.error("Error deleting asset");
                        console.error(error);
                    }
                }
                else if (typeof index === "number") {
                    setAssets(prevAssets => prevAssets.filter((_, idx) => idx !== index));
                }
            },
        });
    };



    const deleteListedStock = (index) => {
        const idToDelete = ListedStocksandBonds[index].Id;

        confirm({
            title: "Are you sure you want to delete?",
            icon: <ExclamationCircleOutlined />,
            okText: "Yes",
            cancelText: "No",
            onOk: async () => {
                try {
                    if (idToDelete) {
                        const res = await _consumerService.deleteStockBondGovSecurityByStockID(idToDelete);
                        if (res.data.IsSuccess) {
                            message.success(res?.data?.Message);
                        } else {
                            message.error(res?.data?.Message || COMMON_ERROR_MSG);
                        }

                    }
                    const updatedList = ListedStocksandBonds.filter(
                        (_, idx) => idx !== index
                    );
                    setListedStocksandBonds(updatedList);
                } catch (error) {
                    console.error("Delete error", error);
                    message.error("Failed to delete");
                }
            },
        });
    };

    const deleteAccountsAndNotes = (index) => {
        const record = accountsAndNotesReceivable[index];
        confirm({
            title: "Are you sure you want to delete?",
            icon: <ExclamationCircleOutlined />,
            okText: "Yes",
            cancelText: "No",
            onOk: async () => {
                if (record.id > 0) {
                    try {
                        const res = await _consumerService.deleteAccountNoteReceivableByAccountID(record.id);
                        if (res.data.IsSuccess) {
                            message.success(res?.data?.Message);
                            setaccountsAndNotesReceivable(prev => prev.filter((_, idx) => idx !== index));
                        } else {
                            message.error(res?.data?.Message || COMMON_ERROR_MSG);
                        }
                    } catch (error) {
                        console.error(error);
                        message.error("An unexpected error occurred.");
                    }
                } else {
                    setaccountsAndNotesReceivable(prev => prev.filter((_, idx) => idx !== index));
                }
            }
        });
    };
    const deleteCashValueAndLifeInsurance = (index) => {
        const record = cashValueAndLifeInsurance[index];
        confirm({
            title: "Are you sure you want to delete?",
            icon: <ExclamationCircleOutlined />,
            okText: "Yes",
            cancelText: "No",
            onOk: async () => {
                if (record.Id > 0) {
                    try {
                        const res = await _consumerService.deleteCashValueLifeInsuranceByCashValueID(record.Id);
                        if (res.data.IsSuccess) {
                            message.success(res?.data?.Message);
                            setCashValueAndLifeInsurance(prev => prev.filter((_, idx) => idx !== index));
                        } else {
                            message.error(res?.data?.Message || COMMON_ERROR_MSG);
                        }
                    } catch (error) {

                        message.error("An unexpected error occurred.");
                    }
                } else {
                    setCashValueAndLifeInsurance(prev => prev.filter((_, idx) => idx !== index));
                }
            }
        });
    };


    const onBack = () => {
        // if (isFromDashboard) {
        //     history.push({ pathname: routes.dashboard.path, state: { appObjId, activeKey: tabActiveKey } });
        // } else {
        //     history.push(routes.expenses.path);
        // }
        if (selectedApplicationDocFlow) {
            history.push({ pathname: routes.expensesForConsumer.path, state: { applicationObjId: appObjId, selectedDocumentOption: selectedApplicationDocFlow } });
        } else {
            history.push({ pathname: routes.consumerDetailsDashboard.path, state: { activeKey: "4" } });
        }

    };


    useEffect(() => {
        if (!locData || (typeof locData === "object" && Object.keys(locData).length === 0)) {
            history.push({ pathname: routes.consumerDashboard.path });
            return;
        }

        fetchAssets();
        fetchListedStocksAndBonds();
        fetchAccountsAndNotes();
        fetchCashValueAndLifeInsurance();
        getBalancesheetassetDataByID();
    }, []);
    useEffect(() => form.resetFields(), [balancesheetassetInfo]);

    const fetchAssets = async () => {
        try {
            const res = await _consumerService.getCashShortTermInvestmentsByApplicationID(fromDashboard ? appObjId : applicationId);
            if (Array.isArray(res.data)) {
                setAssets(res.data);
            }
        } catch (err) {
            console.error("Error fetching assets", err);
        }
    };

    // Save/AddOrUpdate assets
    const saveAssets = async (idx, showMessage = true) => {
        setLoading(true);
        //below code commenitng for to remove validation start
        // let isValid = true;
        // const newErrors = [];

        // assets.forEach((asset) => {
        //     const errObj = {
        //         FinInstitutionalName: !asset.FinInstitutionalName?.trim(),
        //         TypeOfAccount: !asset.TypeOfAccount,
        //         Owner: !asset.Owner,
        //         PledgeToWhome: !asset.PledgeToWhome?.trim(),
        //         Total: !asset.Total,
        //     };

        //     if (Object.values(errObj).some(Boolean)) {
        //         isValid = false;
        //     }
        //     newErrors.push(errObj);
        // });

        // setAssetErrors(newErrors);

        // if (!isValid) {
        //     setLoading(false);
        //     return false;
        // }
        //above code commenitng for to remove validation end

        const payload = {
            ApplicationId: fromDashboard ? appObjId : applicationId,
            listapplicantcashshortterminvestments: assets.map((asset, idx) => ({
                Id: asset.Id || 0,
                ApplicationId: localStorage.getItem("ApplicationObjId"),
                FinInstitutionalName: asset.FinInstitutionalName,
                TypeOfAccount: asset.TypeOfAccount,
                Owner: asset.Owner,
                PledgeToWhome: asset.PledgeToWhome,
                Total: asset.Total
            })),
        };
        try {
            const res = await _consumerService.addUpdateCashShortTermInvestments(payload);
            if (res.data.IsSuccess) {
                setLoading(false);
                if (showMessage) {
                    message.success(res.data.Message);
                }
                return true;
            } else {
                setLoading(false);
                message.destroy();
                message.error(res.data.Message ? res.data.Message : COMMON_ERROR_MSG);
                return false;
            }
        } catch (err) {
            setLoading(false);
            message.destroy();
            message.error(err.message || SUBMISSION_FAILED);
            return false;
        }

    };

    const handleListedStocksChange = (index, field, value) => {
        const updated = [...ListedStocksandBonds];
        updated[index][field] = value;
        setListedStocksandBonds(updated);
    };

    const SaveListedStock = async () => {
        setLoading(true);
        // below validation comment start
        // let isValid = true;
        // const errors = [];
        // ListedStocksandBonds.forEach((item) => {
        //     const errObj = {
        //         noOfShareOrPerValue: !item.noOfShareOrPerValue?.trim(),
        //         whichExchange: !item.whichExchange,
        //         Description: !item.Description?.trim(),
        //         Owner: !item.Owner?.trim(),
        //         CostBasis: !item.CostBasis?.toString().trim(),
        //         marketValue: !item.marketValue?.toString().trim(),
        //         toWhom: !item.toWhom?.trim(),
        //     };

        //     if (Object.values(errObj).some(Boolean)) {
        //         isValid = false;
        //     }

        //     errors.push(errObj);
        // });

        // setListedStockErrors(errors);

        // if (!isValid) {
        //     setLoading(false);
        //     return false;
        // }
        // above validation comment end
        const payload = {
            ApplicationId: fromDashboard ? appObjId : applicationId,
            listApplicantstock: ListedStocksandBonds.map((item) => ({
                Id: item.Id || 0,
                ApplicationId: fromDashboard ? appObjId : applicationId,
                SharesOrParValueBonds_Notes_Bills: item.noOfShareOrPerValue,
                WhichExchage: item.whichExchange,
                Description: item.Description,
                Owner: item.Owner,
                CoastBasis: item.CostBasis,
                PledgeToWhome: item.toWhom,
                MarketValue: item.marketValue,
                CreatedBy: "",
                CreatedDate: new Date(),
                UpdatedBy: "",
                UpdatedDate: new Date(),
            })),
        };

        try {
            const res = await _consumerService.addOrUpdateStockBondGovSecurity(payload);
            if (res.data.IsSuccess) {
                setLoading(false);
                fetchListedStocksAndBonds();
                message.success(res.data.Message)
            } else {
                setLoading(false);
                message.error(res.data.Message ? res.data.Message : COMMON_ERROR_MSG);
            }
        } catch (err) {
            setLoading(false);
            message.error(err.message || SUBMISSION_FAILED);
        }
    };
    const fetchListedStocksAndBonds = async () => {
        try {
            const res = await _consumerService.getStockBondGovSecurityByApplicationID(fromDashboard ? appObjId : applicationId);

            if (Array.isArray(res.data)) {
                const mappedData = res.data.map((item) => ({
                    Id: item.Id,
                    noOfShareOrPerValue: item.SharesOrParValueBonds_Notes_Bills,
                    whichExchange: item.WhichExchage,
                    Description: item.Description,
                    Owner: item.Owner,
                    CostBasis: item.CoastBasis,
                    marketValue: item.MarketValue,
                    toWhom: item.PledgeToWhome,
                }));
                setListedStocksandBonds(mappedData);
            }
        } catch (error) {
            console.error(error);
        }
    };
    const fetchCashValueAndLifeInsurance = async () => {
        try {
            const res = await _consumerService.getCashValueLifeInsuranceByApplicationID(fromDashboard ? appObjId : applicationId);
            if (Array.isArray(res.data)) {
                const mappedData = res.data.map((item) => ({
                    Id: item.Id,
                    nameOfCompany: item.NameOfCompany,
                    policyNumber: item.PolicyNumber,
                    owner: item.Owner,
                    beneficiary: item.Beneficiary,
                    amount: item.Amount,
                    cashValue: item.CashValue,
                    loans: item.Loans
                }));

                setCashValueAndLifeInsurance(mappedData);
            }
        } catch (error) {
            console.error(error);
            //message.error("Failed to load data");
        }
    };

    const handleAccountsAndNotesChange = (idx, field, value) => {
        const updated = [...accountsAndNotesReceivable];
        updated[idx][field] = value;
        setaccountsAndNotesReceivable(updated);
    };
    const saveAccountsAndNotes = async (showMessage = true) => {
        setLoading(true);

        // below validtion comment start
        // let isValid = true;
        // const newErrors = [];
        // accountsAndNotesReceivable.forEach((item) => {
        //     const errObj = {
        //         nameOfDebtor: !item.nameOfDebtor?.trim(),
        //         collateral: !item.collateral?.trim(),
        //         interestRate: !item.interestRate?.toString().trim(),
        //         payable: !item.payable?.toString().trim(),
        //         maturityDate: !item.maturityDate,
        //         unpaidBalance: !item.unpaidBalance?.toString().trim(),
        //         toWhom: !item.toWhom?.trim(),
        //     };

        //     if (Object.values(errObj).some(Boolean)) {
        //         isValid = false;
        //     }

        //     newErrors.push(errObj);
        // });

        // setAccountsAndNotesErrors(newErrors);
        // if (!isValid) {
        //     setLoading(false);
        //     return false;
        // }
        // above validtion comment end

        const payload = {
            ApplicationId: fromDashboard ? appObjId : applicationId,
            listaccountnote: accountsAndNotesReceivable.map(item => ({
                Id: item.id || 0,
                ApplicationId: fromDashboard ? appObjId : applicationId,
                NameOfDebtor: item.nameOfDebtor,
                Collateral: item.collateral,
                InterestRate: item.interestRate,
                Payble: item.payable,
                MaturityDate: item.maturityDate,
                PledgeToWhome: item.toWhom,
                UnpaidBalance: item.unpaidBalance,
                CreatedBy: "",
                CreatedDate: new Date(),
                UpdatedBy: "",
                UpdatedDate: new Date()
            }))
        };
        try {
            const res = await _consumerService.AddOrUpdateAccountNoteReceivable(payload);
            if (res.data.IsSuccess) {
                setLoading(false);
                message.success(res.data.Message);
                fetchAccountsAndNotes();
            } else {
                setLoading(false);
                message.error(res.data.Message ? res.data.Message : COMMON_ERROR_MSG);
            }
        } catch (err) {
            setLoading(false);
            message.error(err.message || SUBMISSION_FAILED);
        }
    };
    const fetchAccountsAndNotes = async () => {
        try {
            const res = await _consumerService.getAccountNoteReceivableByApplicationID(fromDashboard ? appObjId : applicationId);
            if (Array.isArray(res.data)) {
                const mappedData = res.data.map((item) => ({
                    id: item.Id,
                    nameOfDebtor: item.NameOfDebtor,
                    collateral: item.Collateral,
                    interestRate: item.InterestRate,
                    payable: item.Payble,
                    maturityDate: item.MaturityDate,
                    unpaidBalance: item.UnpaidBalance,
                    toWhom: item.PledgeToWhome
                }));
                setaccountsAndNotesReceivable(mappedData);
            }
        } catch (error) {
            console.error(error);
        }
    };
    const handleInputChange = (index, field, value) => {
        const updated = [...cashValueAndLifeInsurance];
        updated[index][field] = value;
        setCashValueAndLifeInsurance(updated);
    };
    const saveCashValueAndLifeInsurace = async () => {
        setLoading(false);
        // below validation comment start
        // let isValid = true;
        // const newErrors = [];
        // cashValueAndLifeInsurance.forEach((item) => {
        //     const errObj = {
        //         nameOfCompany: !item.nameOfCompany?.trim(),
        //         beneficiary: !item.beneficiary?.trim(),
        //         owner: !item.owner?.trim(),
        //         loans: !item.loans?.toString().trim(),
        //         cashValue: !item.cashValue?.toString().trim(),
        //         amount: !item.amount?.toString().trim(),
        //     };
        //     if (Object.values(errObj).some(Boolean)) {
        //         isValid = false;
        //     }
        //     newErrors.push(errObj);
        // });
        // setCashValueErrors(newErrors);
        // if (!isValid) {
        //     setLoading(false);
        //     return false;
        // }
        // above validation comment end

        const payload = {
            ApplicationId: fromDashboard ? appObjId : applicationId,
            listcashvalueinshurance: cashValueAndLifeInsurance.map((item) => ({
                Id: item.id || 0,
                ApplicationId: fromDashboard ? appObjId : applicationId,
                NameOfCompany: item.nameOfCompany,
                Beneficiary: item.beneficiary,
                Owner: item.owner,
                Loans: item.loans,
                CashValue: item.cashValue,
                Amount: item.amount,
                CreatedBy: "",
                CreatedDate: new Date(),
                UpdatedBy: "",
                UpdatedDate: new Date(),
            })),
        };
        try {
            const res = await _consumerService.addOrUpdateCashValueLifeInsurance(payload);
            if (res.data.IsSuccess) {
                setLoading(false);
                message.success(res.data.Message);            
                fetchCashValueAndLifeInsurance();
            } else {
                setLoading(false);
                message.error(res.data.Message ? res.data.Message : COMMON_ERROR_MSG);
            }
        } catch (err) {
            setLoading(false);
            message.error(err.message || SUBMISSION_FAILED);
        }


    };
    const onFinish = async (values) => {
        const totalAssets = parseFloat(values?.totalLiquidMarketableAssets);
        if (!totalAssets || isNaN(totalAssets) || totalAssets <= 0) {
            message.error("Please enter an amount in at least one field (Total Assets should not be 0)");
            return false;
        }
        
        setLoading(true);
        // below validation commenting  start
        // const isAssetsSaved = await saveAssets(false);
        // const isListedStockSaved = await SaveListedStock(false);
        // const isAccountsAndNotesSaved = await saveAccountsAndNotes(false);
        // const isCashValueSaved = await saveCashValueAndLifeInsurace(false);

        // // If any validation failed, return early
        // if (!isAssetsSaved || !isListedStockSaved || !isAccountsAndNotesSaved || !isCashValueSaved) {
        //     setLoading(false);
        //     message.error("Please correct validation errors in the form before submitting.");
        //     return;
        // }
        // above validation commenting  end
        try {
            const payload = {
                Id:applicationId,
                ScreenName: ScreenNamebalancesheetasset,
                ApplicationId: localStorage.getItem("ApplicationObjId"),
                CashShortTermInvestmentsTotal: values.CashShortTermInvestmentsTotal,
                StockBondGovSecurityTotal: values.StockBondGovSecurityTotal,
                AccountNoteReceivableTotal: values.AccountNoteReceivableTotal,
                CashValueLifeInsuranceTotal: values.CashValueLifeInsuranceTotal,
                OtherLiquidAssetsTotal: values.otherliquidassets,
                LiquidMarketableAssetsTotal: values.totalLiquidMarketableAssets,
                IsBalancesheetAssetCompleted: true,
            };

            const res = await _consumerService.updateApplicantFinancialData(payload);

            if (res.data.IsSuccess) {
                setLoading(false);
                message.destroy();
                message.success(res.data.Message);
                getBalancesheetassetDataByID();
                // if (isFromDashboard) {
                //     history.push({ pathname: routes.dashboard.path, state: { appObjId, activeKey: tabActiveKey } });
                // }
                // else {
                //     history.push(routes.balanceSheetTotalAssets.path);

                // }

                if (selectedApplicationDocFlow) {
                    history.push({ pathname: routes.balanceSheetTotalAssetsForConsumer.path, state: { appObjId, activeKey: tabActiveKey, selectedDocumentOption: selectedApplicationDocFlow } });
                }
                else {
                  history.push({ pathname: routes.consumerDetailsDashboard.path, state: { activeKey: "4" } });

                }

      //history.push({ pathname: routes.consumerDetailsDashboard.path, state: { activeKey: "4" } });

            } else {
                setLoading(false);
                message.error("Failed to submit data.");
            }
        } catch (error) {
            setLoading(false);
            console.error("API Error:", error);
            message.error("An error occurred while submitting the data.");
        }

    };
    const getBalancesheetassetDataByID = async () => {
        try {
             setLoading(true);
            const res = await _consumerService.getFinancialStatementData(fromDashboard ? appObjId : applicationId, ScreenNamebalancesheetasset);

            if (res.data) {
                let resObj = res?.data.Obj;
                setBalancesheetassetInfo({
                    CashShortTermInvestmentsTotal:normalizeNumber(resObj.CashShortTermInvestmentsTotal) ,
                    StockBondGovSecurityTotal: normalizeNumber(resObj.StockBondGovSecurityTotal),
                    AccountNoteReceivableTotal: normalizeNumber(resObj.AccountNoteReceivableTotal),
                    CashValueLifeInsuranceTotal:normalizeNumber(resObj.CashValueLifeInsuranceTotal) ,
                    otherliquidassets:normalizeNumber(resObj.OtherLiquidAssetsTotal),
                    totalLiquidMarketableAssets:normalizeNumber(resObj.LiquidMarketableAssetsTotal),
                    Application_Status_Id: resObj.Application_Status_Id
                });
                  

                // setLoading(false);
            }
        } catch (e) {
            // setLoading(false);
            console.log(e);
        } finally {
            setLoading(false);
        }
    };
    const handleValuesChange = (changedValues, allValues) => {
        const total = Object.entries(allValues).reduce((acc, [key, value]) => {
            if (key === 'totalLiquidMarketableAssets') return acc;
            const num = parseFloat(value);
            return acc + (isNaN(num) ? 0 : num);
        }, 0);

        // setBalancesheetassetInfo({
        //     ...allValues,
        //     totalLiquidMarketableAssets: total,
        // });
        form.setFieldsValue({
            totalLiquidMarketableAssets: total.toFixed(2),
        });

    };
    return (
        <Spin spinning={loading}>
            <LeftLayout>
                {applicationId && applicationId !== 'undefined' && applicationId !== 'null' && (
                    <div style={{
                        position: "absolute",
                        top: 5,
                        right: 20,
                        margin: 0,
                        zIndex: 1000,
                        maxWidth: "1000px",
                        padding: "8px 16px",
                        display: "none"
                    }}>
                        <ConsumerApplicationProgressBar />
                        <Title level={3} style={{ margin: 0 }}>
                            <ConsumerShowApplicationId />
                        </Title>
                    </div>
                )}


                <div className="pageSubBackgroundForBalanceAssetPageWrapper">
                    <div className="pageSubBackgroundForBalanceAssetPageCard">

                <Row  align="top" className="balance-sheet-total-assets-wrapper inputBoxStyle balance-w">
                    <Col span={24}>
                        <Title level={3} >
                            Balance Sheet - Assets (Liquid/Marketable Assets)
                        </Title>
                        <Form
                            form={form}
                            layout="vertical"
                            onFinish={onFinish}
                            className="addMultipleRowForm"
                            initialValues={balancesheetassetInfo}
                            onValuesChange={handleValuesChange}
                        >
                            <Card className="mb15 cardViewMain">
                                <Collapse
                                    accordion
                                    expandIconPosition="end"
                                    ghost
                                    expandIcon={({ isActive }) => (
                                        <span style={{ color: '#1890ff', fontWeight: 'bold' }}>
                                            {isActive ? 'Hide Details' : 'Add Details'}
                                        </span>
                                    )}
                                    style={{ backgroundColor: "transparent" }}
                                    key="1"
                                    collapsible="icon"
                                    header={
                                        <Row justify="space-between" align="middle">
                                            <Col className="left-balance">
                                                <label>Cash & Short-Term Investments 
                                                    {/* <span style={{ color: 'red' }}> *</span> */}
                                                    </label>
                                            </Col>
                                            <Col className="right-balance">
                                                <Form.Item
                                                    style={{ marginBottom: 0 }}
                                                    name="CashShortTermInvestmentsTotal"
                                                >

                                                    <CurrencyInput placeholder="Enter Amount" />
                                                </Form.Item>
                                            </Col>
                                        </Row>
                                    }
                                >
                                    <Panel
                                        style={{ backgroundColor: "transparent" }}
                                        key="1"
                                        collapsible="icon"
                                        header={
                                            <Row justify="space-between" align="middle" style={{ width: "100%" }}>
                                                <Col className="left-balance">
                                                    <label className="f16Bold">Cash & Short-Term Investments 
                                                        {/* <span style={{ color: 'red' }}> *</span> */}
                                                    </label>
                                                </Col>
                                                <Col className="right-balance">
                                                    <Form.Item
                                                        // rules={[
                                                        //     {-                                                        //         required: true,
                                                        //         message: 'Cash & Short-Term Investments is required',
                                                        //     }
                                                        // ]}
                                                        style={{ marginBottom: 0 }}
                                                        name="CashShortTermInvestmentsTotal"
                                                    >

                                                        <CurrencyInput placeholder="Enter Amount" />
                                                    </Form.Item>
                                                </Col>
                                            </Row>
                                        }
                                    >

                                        {assets.map((asset, idx) => (
                                            <div key={idx} className="balancesheetpdm">
                                                <Row justify="end" align="middle">
                                                    <Col>
                                                        <Input type="hidden" name={asset.Id} Id={asset.Id} />
                                                        {idx > 0 && (
                                                            <Button
                                                                type="text"
                                                                icon={<DeleteOutlined style={{ fontSize: 18 }} />}
                                                                onClick={() => deleteAsset(asset.Id, idx)}
                                                            />
                                                        )}
                                                    </Col>
                                                </Row>

                                                {/* Name of Financial Institution */}
                                                <Form.Item label="Name of Financial Institution" className="w50">
                                                    <Input
                                                        placeholder="Enter Name of Financial Institution"
                                                        value={asset.FinInstitutionalName}
                                                        onChange={(e) => {
                                                            const updated = [...assets];
                                                            updated[idx].FinInstitutionalName = e.target.value;
                                                            setAssets(updated);
                                                        }}
                                                    />
                                                    {/* {assetErrors[idx]?.FinInstitutionalName && (
                                                        <div className="ant-form-item-explain-error">Name of Financial Institution is required</div>
                                                    )} */}
                                                </Form.Item>

                                                {/* Type of Account */}
                                                <Form.Item label="Type of Account" className="w50">
                                                    <Select
                                                        allowClear
                                                        value={asset.TypeOfAccount}
                                                        onChange={(value) => {
                                                            const updated = [...assets];
                                                            updated[idx].TypeOfAccount = value;
                                                            setAssets(updated);
                                                        }}
                                                        placeholder="Select Type of Account"
                                                    >
                                                        <Option value={"1"}>Saving</Option>
                                                        <Option value={"2"}>Current</Option>
                                                    </Select>
                                                    {/* {assetErrors[idx]?.TypeOfAccount && (
                                                        <div className="ant-form-item-explain-error">Type of Account is required</div>
                                                    )} */}
                                                </Form.Item>

                                                {/* Owner */}
                                                <Form.Item label="Owner" className="w50">
                                                    <Input
                                                        value={asset.Owner}
                                                        placeholder="Enter Owner"
                                                        onChange={(e) => {
                                                            const updated = [...assets];
                                                            updated[idx].Owner = e.target.value;
                                                            setAssets(updated);
                                                        }}
                                                    />
                                                    {/* {assetErrors[idx]?.Owner && (
                                                        <div className="ant-form-item-explain-error">Owner is required</div>
                                                    )} */}
                                                </Form.Item>

                                                {/* Pledged To Whom */}
                                                <Form.Item label="If Pledged, to whom?" className="w50">
                                                    <Input
                                                        placeholder="Enter Pledged, to whom?"
                                                        value={asset.PledgeToWhome}
                                                        onChange={(e) => {
                                                            const updated = [...assets];
                                                            updated[idx].PledgeToWhome = e.target.value;
                                                            setAssets(updated);
                                                        }}
                                                    />
                                                    {/* {assetErrors[idx]?.PledgeToWhome && (
                                                        <div className="ant-form-item-explain-error">Pledge To Whom is required</div>
                                                    )} */}
                                                </Form.Item>

                                                {/* Total */}
                                                <Form.Item label="Total Amount" className="w50">
                                                    {/* <Input
                                                        placeholder="Enter Total Amount"
                                                        prefix="$"
                                                        type="number"
                                                        value={asset.Total}
                                                        onChange={(e) => {
                                                            const updated = [...assets];
                                                            updated[idx].Total = e.target.value;
                                                            setAssets(updated);
                                                        }}
                                                    /> */}
                                                    <CurrencyInput 
                                                        placeholder="Enter Total Amount"
                                                        value={asset.Total}
                                                        onChange={(val) => {
                                                            const updated = [...assets];
                                                            updated[idx].Total = val;
                                                            setAssets(updated);
                                                        }}
                                                    />
                                                    {/* {assetErrors[idx]?.Total && (
                                                        <div className="ant-form-item-explain-error">Total Amount is required</div>
                                                    )} */}
                                                </Form.Item>
                                            </div>
                                        ))}
                                        <Form.Item style={{ textAlign: "right" }}>
                                            <Button
                                                type="link"
                                                icon={<PlusCircleOutlined/>}
                                                className="f16"
                                                onClick={addAsset}
                                                disabled={![1,6].includes(balancesheetassetInfo && balancesheetassetInfo.Application_Status_Id) ? true : false}
                                            >
                                                Add More
                                            </Button>
                                            <Button
                                                type="primary"
                                                onClick={saveAssets}
                                                disabled={![1,6].includes(balancesheetassetInfo && balancesheetassetInfo.Application_Status_Id) ? true : false}
                                            >
                                                Save
                                            </Button>
                                        </Form.Item>

                                    </Panel>
                                </Collapse>
                            </Card>


                            <Card className="mb15 cardViewMain">
                                <Collapse
                                    accordion
                                    expandIconPosition="end"
                                    ghost
                                    expandIcon={({ isActive }) => (
                                        <span style={{ color: '#1890ff', fontWeight: 'bold' }}>
                                            {isActive ? 'Hide Details' : 'Add Details'}
                                        </span>
                                    )}
                                    style={{ backgroundColor: "transparent" }}
                                >
                                    <CollapsePanel
                                        key="1"
                                        collapsible="icon"
                                        header={
                                            <Row justify="space-between" align="middle" style={{ width: "100%" }}>
                                                <Col className="left-balance">
                                                    <label className="f16Bold">Listed Stocks and Bonds & Gov't Securities 
                                                        {/* <span style={{ color: 'red' }}> *</span> */}
                                                    </label>
                                                </Col>
                                                <Col className="right-balance">
                                                    <Form.Item name="StockBondGovSecurityTotal" style={{ marginBottom: 0 }}
                                                        // rules={[
                                                        //     {
                                                        //         required: true,
                                                        //         message: 'Listed Stocks and Bonds & Govt Securities is required',
                                                        //     }
                                                        // ]}
                                                    >
                                                        <CurrencyInput placeholder="Enter Amount" />
                                                    </Form.Item>
                                                </Col>
                                            </Row>
                                        }
                                    >

                                        {ListedStocksandBonds.map((item, idx) => (
                                            <div key={idx} className="balancesheetpdm">
                                                <Row justify="end">
                                                    <Col><Input type="hidden" name={item.Id} Id={item.Id} /></Col>
                                                    <Col>
                                                        {idx > 0 && (
                                                            <Button
                                                                type="text"
                                                                icon={<DeleteOutlined style={{ fontSize: 18 }} />}
                                                                onClick={() => deleteListedStock(idx)}
                                                            />
                                                        )}
                                                    </Col>
                                                </Row>

                                                <Form.Item label="No. Shares or Par Value of Bonds, Notes, Bills" className="w50">
                                                    <Input
                                                        placeholder="Enter No. Shares or Par Value of Bonds, Notes, Bills"
                                                        type="number"
                                                        value={item.noOfShareOrPerValue}
                                                        onChange={(e) => handleListedStocksChange(idx, "noOfShareOrPerValue", e.target.value)}
                                                    />
                                                    {/* <CurrencyInput 
                                                        placeholder="Enter No. Shares or Par Value of Bonds, Notes, Bills"
                                                        value={item.noOfShareOrPerValue}
                                                        onChange={(val) => handleListedStocksChange(idx, "noOfShareOrPerValue", val)}
                                                    /> */}
                                                    {/* {listedStockErrors[idx]?.noOfShareOrPerValue && (
                                                        <div className="ant-form-item-explain-error">This field is required</div>
                                                    )} */}
                                                </Form.Item>

                                                <Form.Item label="Exchange" className="w50">
                                                    <Input
                                                        value={item.whichExchange}
                                                        onChange={(e) => handleListedStocksChange(idx, "whichExchange", e.target.value)}
                                                        placeholder="Enter Exchange"
                                                    />
                                                    {/* {listedStockErrors[idx]?.whichExchange && (
                                                        <div className="ant-form-item-explain-error">Exchange is required</div>
                                                    )} */}
                                                </Form.Item>


                                                <Form.Item label="Description" className="w50">
                                                    <Input
                                                        placeholder="Enter Description"
                                                        value={item.Description}
                                                        onChange={(e) => handleListedStocksChange(idx, "Description", e.target.value)}
                                                    />
                                                    {/* {listedStockErrors[idx]?.Description && (
                                                        <div className="ant-form-item-explain-error">Description is required</div>
                                                    )} */}
                                                </Form.Item>


                                                {/* <Form.Item label="Owner" className="w50" required>
                                                    <Select
                                                        allowClear
                                                        value={ListedStocksandBonds.Owner}
                                                        placeholder="Enter Owner"
                                                        onChange={(value) => {
                                                            const updated = [...ListedStocksandBonds];
                                                            updated[idx].Owner = value;
                                                            setListedStocksandBonds(updated);
                                                        }}
                                                    >
                                                        <Option value={"1"}>Borrower</Option>
                                                        <Option value={"2"}>Guarantor</Option>
                                                    </Select>
                                                    {listedStockErrors[idx]?.Owner && <div className="ant-form-item-explain-error">Owner is required</div>}
                                                </Form.Item> */}

                                                <Form.Item label="Owner" className="w50">
                                                    <Input 
                                                     value={ListedStocksandBonds[idx].Owner}
                                                        placeholder="Enter Owner"
                                                        onChange={(e) => {
                                                            const updated = [...ListedStocksandBonds];                                                        
                                                                updated[idx].Owner = e.target.value;
                                                                setListedStocksandBonds(updated);                                                        
                                                        }}
                                                    />                                                   

                                                    {/* {listedStockErrors[idx]?.Owner && (
                                                        <div className="ant-form-item-explain-error">
                                                            Owner is required
                                                        </div>
                                                    )} */}
                                                </Form.Item>



                                                <Form.Item label="Cost Basis" className="w50">                                                  
                                                    <CurrencyInput 
                                                         placeholder="Enter Cost Basis"
                                                        value={item.CostBasis}
                                                        onChange={(val) => handleListedStocksChange(idx, "CostBasis", val)}
                                                    />
                                                    {/* {listedStockErrors[idx]?.CostBasis && (
                                                        <div className="ant-form-item-explain-error">Cost Basis is required</div>
                                                    )} */}
                                                </Form.Item>

                                                <Form.Item label="Market Value" className="w50">
                                                    
                                                    <CurrencyInput 
                                                         placeholder="Enter Market Value"
                                                        value={item.marketValue}
                                                        onChange={(val) => handleListedStocksChange(idx, "marketValue", val)}
                                                    />
                                                    {/* {listedStockErrors[idx]?.marketValue && (
                                                        <div className="ant-form-item-explain-error">Market Value is required</div>
                                                    )} */}
                                                </Form.Item>

                                                <Form.Item label="If Pledged, to whom?" className="w50">
                                                    <Input
                                                        placeholder="Enter If Pledged, to whom?"
                                                        value={item.toWhom}
                                                        onChange={(e) => handleListedStocksChange(idx, "toWhom", e.target.value)}
                                                    />
                                                    {/* {listedStockErrors[idx]?.toWhom && (
                                                        <div className="ant-form-item-explain-error">If Pledged, to whom is required</div>
                                                    )} */}
                                                </Form.Item>
                                            </div>
                                        ))}

                                        <Form.Item style={{ textAlign: "right" }}>
                                            <Button
                                                type="link"
                                                icon={<PlusCircleOutlined />}
                                                className="f16"
                                                onClick={addListedStock}
                                                disabled={![1, 6].includes(balancesheetassetInfo && balancesheetassetInfo.Application_Status_Id) ? true : false}
                                            >
                                                Add More
                                            </Button>
                                            <Button
                                                type="primary"
                                                onClick={SaveListedStock}
                                                disabled={![1, 6].includes(balancesheetassetInfo && balancesheetassetInfo.Application_Status_Id) ? true : false}
                                            >
                                                Save
                                            </Button>
                                        </Form.Item>

                                    </CollapsePanel>
                                </Collapse>
                            </Card>

                            <Card className="mb15 cardViewMain">
                                <Collapse
                                    accordion
                                    expandIconPosition="end"
                                    ghost
                                    expandIcon={({ isActive }) => (
                                        <span style={{ color: '#1890ff', fontWeight: 'bold' }}>
                                            {isActive ? 'Hide Details' : 'Add Details'}
                                        </span>
                                    )}
                                    style={{ backgroundColor: "transparent" }}
                                >
                                    <CollapsePanel
                                        key="1"
                                        collapsible="icon"
                                        header={
                                            <Row justify="space-between" align="middle" style={{ width: "100%" }}>
                                                <Col className="left-balance">
                                                    <label className="f16Bold">Accounts and Notes Receivable 
                                                        {/* <span style={{ color: 'red' }}> *</span> */}
                                                    </label>
                                                </Col>
                                                <Col className="right-balance">
                                                    <Form.Item name="AccountNoteReceivableTotal"
                                                        // rules={[
                                                        //     {
                                                        //         required: true,
                                                        //         message: 'Accounts and Notes Receivable is required',
                                                        //     },
                                                        // ]}
                                                    >
                                                        <CurrencyInput placeholder="Enter Amount" />
                                                    </Form.Item>
                                                </Col>
                                            </Row>
                                        }
                                    >
                                        {accountsAndNotesReceivable.map((accountsAndNotes, idx) => (
                                            <div key={idx}  className="balancesheetpdm">
                                                <Row justify="end" align="middle">
                                                    <Col>
                                                        {idx > 0 && (
                                                            <Button
                                                                type="text"
                                                                icon={<DeleteOutlined style={{ fontSize: 18 }} />}
                                                                onClick={() => deleteAccountsAndNotes(idx)}
                                                            />
                                                        )}
                                                    </Col>
                                                </Row>

                                                <Form.Item label="Name of Debtor" className="w50">
                                                    <Input
                                                        placeholder="Enter Name of Debtor"
                                                        value={accountsAndNotes.nameOfDebtor}
                                                        onChange={(e) => handleAccountsAndNotesChange(idx, "nameOfDebtor", e.target.value)}
                                                    />
                                                    {/* {accountsAndNotesErrors[idx]?.nameOfDebtor && (
                                                        <div className="ant-form-item-explain-error">Name of Debtor is required</div>
                                                    )} */}
                                                </Form.Item>

                                                <Form.Item label="Collateral" className="w50">
                                                    <Input
                                                        placeholder="Enter Collateral"
                                                        value={accountsAndNotes.collateral}
                                                        onChange={(e) => handleAccountsAndNotesChange(idx, "collateral", e.target.value)}
                                                    />
                                                    {/* {accountsAndNotesErrors[idx]?.collateral && (
                                                        <div className="ant-form-item-explain-error">Collateral is required</div>
                                                    )} */}
                                                </Form.Item>

                                                <Form.Item label="Interest Rate %" className="w50" >                                                  
                                                    {/* <CurrencyInput 
                                                        placeholder="Enter Interest Rate %"
                                                        value={accountsAndNotes.interestRate}
                                                        onChange={(val) => handleAccountsAndNotesChange(idx, "interestRate",val)}
                                                    /> */}

                                                     <Input 
                                                        placeholder="Enter Interest Rate %"
                                                        value={accountsAndNotes.interestRate}
                                                        onChange={(e) => handleAccountsAndNotesChange(idx, "interestRate", e.target.value)}
                                                    />
                                                    {/* {accountsAndNotesErrors[idx]?.interestRate && (
                                                        <div className="ant-form-item-explain-error">Interest Rate % is required</div>
                                                    )} */}
                                                </Form.Item>

                                                <Form.Item label="Payable" className="w50">                                                   
                                                    <CurrencyInput 
                                                        placeholder="Enter Payable"
                                                        value={accountsAndNotes.payable}
                                                        onChange={(val) => handleAccountsAndNotesChange(idx, "payable", val)}
                                                    />
                                                    {/* {accountsAndNotesErrors[idx]?.payable && (
                                                        <div className="ant-form-item-explain-error">Payable is required</div>
                                                    )} */}
                                                </Form.Item>

                                                <Form.Item label="Maturity Date" className="w50">
                                                    <DatePicker
                                                        placeholder="Select Maturity Date"
                                                        style={{ width: "100%" }}
                                                        format="MM/DD/YYYY"
                                                        value={
                                                            accountsAndNotes.maturityDate
                                                                ? moment(accountsAndNotes.maturityDate, "YYYY-MM-DD")
                                                                : null
                                                        }
                                                        onChange={(date, dateString) =>
                                                            handleAccountsAndNotesChange(idx, "maturityDate", date?.format("YYYY-MM-DD"))
                                                        }
                                                        disabledDate={(current) => current && current.isBefore(moment(), "day")}
                                                    />
                                                    {/* {accountsAndNotesErrors[idx]?.maturityDate && (
                                                        <div className="ant-form-item-explain-error">Maturity Date is required</div>
                                                    )} */}
                                                </Form.Item>

                                                <Form.Item label="Unpaid Balance" className="w50">                                                   
                                                    <CurrencyInput 
                                                        placeholder="Unpaid Balance"
                                                        value={accountsAndNotes.unpaidBalance}
                                                        onChange={(val) => handleAccountsAndNotesChange(idx, "unpaidBalance", val)}
                                                    />
                                                    {/* {accountsAndNotesErrors[idx]?.unpaidBalance && (
                                                        <div className="ant-form-item-explain-error">Unpaid Balance is required</div>
                                                    )} */}
                                                </Form.Item>

                                                <Form.Item label="If Pledged, to whom?" className="w50">
                                                    <Input
                                                        placeholder="Enter If Pledged, to whom?"
                                                        value={accountsAndNotes.toWhom}
                                                        onChange={(e) => handleAccountsAndNotesChange(idx, "toWhom", e.target.value)}
                                                    />
                                                    {/* {accountsAndNotesErrors[idx]?.toWhom && (
                                                        <div className="ant-form-item-explain-error">If Pledged, to whom is required</div>
                                                    )} */}
                                                </Form.Item>
                                            </div>
                                        ))}

                                        <Form.Item style={{ textAlign: "right" }} >
                                            <Button
                                                type="link"
                                                icon={<PlusCircleOutlined />}
                                                className="f16"
                                                onClick={addAccountsNoter}
                                                disabled={![1, 6].includes(balancesheetassetInfo && balancesheetassetInfo.Application_Status_Id) ? true : false}
                                            >
                                                Add More
                                            </Button>
                                            <Button
                                                type="primary"
                                                onClick={saveAccountsAndNotes}
                                                disabled={![1 , 6].includes(balancesheetassetInfo && balancesheetassetInfo.Application_Status_Id) ? true : false}
                                            >
                                                Save
                                            </Button>
                                        </Form.Item>
                                    </CollapsePanel>
                                </Collapse>
                            </Card>


                            <Card className="mb15 cardViewMain">
                                <Collapse accordion expandIconPosition="end" ghost expandIcon={({ isActive }) => (
                                    <span style={{ color: '#1890ff', fontWeight: 'bold' }}>
                                        {isActive ? 'Hide Details' : 'Add Details'}
                                    </span>
                                )} style={{ backgroundColor: "transparent" }}>
                                    <CollapsePanel
                                        key="1"
                                        collapsible="icon"
                                        header={
                                            <Row justify="space-between" align="middle" style={{ width: "100%" }}>
                                                <Col className="left-balance">
                                                    <label className="f16Bold">Cash Value (Net of Policy Loans) Life Insurance 
                                                        {/* <span style={{ color: 'red' }}> *</span> */}
                                                    </label>
                                                </Col>
                                                <Col className="right-balance">
                                                    <Form.Item name="CashValueLifeInsuranceTotal"
                                                        // rules={[
                                                        //     {
                                                        //         required: true,
                                                        //         message: 'Cash Value (Net of Policy Loans) Life Insurance is required',
                                                        //     },
                                                        // ]}
                                                    >
                                                        <CurrencyInput placeholder="Enter Amount" />
                                                    </Form.Item>
                                                </Col>
                                            </Row>
                                        }
                                    >
                                        {cashValueAndLifeInsurance.map((item, idx) => (
                                            <div key={idx} className="balancesheetpdm">
                                                <Row justify="end" align="middle">
                                                    <Col>
                                                        {idx > 0 && (
                                                            <Button
                                                                type="text"
                                                                icon={<DeleteOutlined style={{ fontSize: 18 }} />}
                                                                onClick={() => deleteCashValueAndLifeInsurance(idx)}
                                                            />
                                                        )}
                                                    </Col>
                                                </Row>

                                                <Form.Item label="Name of Company" className="w50">
                                                    <Input
                                                        placeholder="Enter Name of Company"
                                                        value={item.nameOfCompany}
                                                        onChange={(e) => handleInputChange(idx, "nameOfCompany", e.target.value)}
                                                    />
                                                    {/* {cashValueErrors[idx]?.nameOfCompany && (
                                                        <div className="ant-form-item-explain-error">Name of Company is required</div>
                                                    )} */}
                                                </Form.Item>

                                                <Form.Item label="Beneficiary" className="w50">
                                                    <Input
                                                        placeholder="Enter Beneficiary"
                                                        value={item.beneficiary}
                                                        onChange={(e) => handleInputChange(idx, "beneficiary", e.target.value)}
                                                    />
                                                    {/* {cashValueErrors[idx]?.beneficiary && (
                                                        <div className="ant-form-item-explain-error">Beneficiary is required</div>
                                                    )} */}
                                                </Form.Item>


                                                <Form.Item label="Owner" className="w50">
                                                    <Input type="text"
                                                        value={cashValueAndLifeInsurance[idx].owner}
                                                        placeholder="Enter Owner"
                                                        onChange={(e) => {
                                                            const updated = [...cashValueAndLifeInsurance];                                                        
                                                                updated[idx].owner = e.target.value;
                                                                setCashValueAndLifeInsurance(updated);
                                                            
                                                        }}
                                                    />                                            

                                                    {/* {cashValueErrors[idx]?.owner && (
                                                        <div className="ant-form-item-explain-error">Owner is required</div>
                                                    )} */}
                                                </Form.Item>



                                                <Form.Item label="Loans" className="w50">                                                   
                                                    <CurrencyInput 
                                                        placeholder="Enter Loans"
                                                        value={item.loans}
                                                        onChange={(val) => handleInputChange(idx, "loans", val)}
                                                    />
                                                    {/* {cashValueErrors[idx]?.loans && (
                                                        <div className="ant-form-item-explain-error">Loans is required</div>
                                                    )} */}
                                                </Form.Item>

                                                <Form.Item label="Cash Value" className="w50">                                                   
                                                    <CurrencyInput
                                                        placeholder="Enter Cash Value"
                                                        value={item.cashValue}
                                                        onChange={(val) => handleInputChange(idx, "cashValue", val)}
                                                    />
                                                    {/* {cashValueErrors[idx]?.cashValue && (
                                                        <div className="ant-form-item-explain-error">Cash Value is required</div>
                                                    )} */}
                                                </Form.Item>

                                                <Form.Item label="Amount" className="w50">
                                                    <CurrencyInput 
                                                         placeholder="Enter Amount"
                                                        value={item.amount}
                                                        onChange={(val) => handleInputChange(idx, "amount", val)}
                                                    />
                                                    {/* {cashValueErrors[idx]?.amount && (
                                                        <div className="ant-form-item-explain-error">Amount is required</div>
                                                    )} */}
                                                </Form.Item>
                                            </div>
                                        ))}

                                        <Form.Item style={{ textAlign: "right" }}>
                                            <Button
                                                type="link"
                                                icon={<PlusCircleOutlined/>}
                                                className="f16"
                                                onClick={addCashValueAndLifeInsurance}
                                                disabled={![1, 6].includes(balancesheetassetInfo && balancesheetassetInfo.Application_Status_Id) ? true : false}
                                            >
                                                Add More
                                            </Button>
                                            <Button
                                                type="primary"
                                                onClick={saveCashValueAndLifeInsurace}
                                               disabled={![1,6].includes(balancesheetassetInfo && balancesheetassetInfo.Application_Status_Id) ? true : false}
                                            >
                                                Save
                                            </Button>
                                        </Form.Item>
                                    </CollapsePanel>
                                </Collapse>
                            </Card>

                            <Row className="cardViewMain mb15 cardnew">
                                <Col className="left-balance">
                                    <label className="f16Bold">
                                        Other Liquid Assets  
                                        {/* <span style={{ color: 'red' }}> *</span> */}
                                    </label>
                                </Col>
                                <Col className="right-balance">
                                    <Form.Item
                                        name="otherliquidassets"
                                    >
                                        <CurrencyInput placeholder="Enter Amount" />
                                    </Form.Item>
                                </Col>
                            </Row>
                            <Row className="cardViewMain mb15 cardnew">
                                <Col className="left-balance">
                                    <label className="f16Bold">TOTAL LIQUID/MARKETABLE ASSETS</label>
                                </Col>
                                <Col className="right-balance">
                                    <Form.Item
                                        name="totalLiquidMarketableAssets"
                                        //  rules={[
                                        //     {
                                        //         validator: (_, value) => {
                                        //             if (!value || Number(value) <= 0) {
                                        //                 return Promise.reject(new Error("Value should not be 0."));
                                        //             }
                                        //             return Promise.resolve();
                                        //         },
                                        //     },
                                        // ]}
                                        rules={[{ required: false, message: "Total Assets is required" }]}
                                    >
                                        <CurrencyInput disabled />
                                    </Form.Item>
                                </Col>
                            </Row> 



                            <Form.Item style={{ marginTop: "20px" }}>
                                <div style={{ display: "flex", justifyContent: "flex-end", gap: 16 }}>
                                    <Button
                                        onClick={onBack}
                                        icon={<LeftOutlined />}
                                    >
                                        Go Back
                                    </Button>
                                    <Button
                                        type="primary"
                                        htmlType="submit"
                                        disabled={![1, 6].includes(balancesheetassetInfo && balancesheetassetInfo.Application_Status_Id) ? true : false}
                                    >
                                        Save And Proceed <RightOutlined />
                                    </Button>
                                </div>
                            </Form.Item>
                        </Form>
                    </Col>
                </Row>
                </div>
                </div>
            </LeftLayout>
        </Spin>
    );
};

export default BalanceSheetAssetsForConsumer;

